<template>
  <strong>
    <a class="link-tag" text :href="telephoneRef" @click="onPhoneNumber">{{phone}}</a>
  </strong>
</template>

<script>
export default {
  props: ["phone"],
  name: "phone-number",

  data: () => ({
    telephoneRef: '',
  }),

  methods: {
    onPhoneNumber() {
      console.log("Phone Number: ", this.phone)
    }
  },

  mounted() {
      this.telephoneRef = 'tel:/' + this.phone
  }
};
</script>

<style lang="scss" scoped>
</style>
